
import React from "react";

export default function AlwaysVisibleScrollbar() {
  return null;
}
